export const homeObjOne5 = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDes: true,
    topLine: 'Prestige Event & Catering ',
    headline: '30 års erfarenhet – vi skapar upplevelser att minnas',
    description: 'Med över 30 års erfarenhet inom event, catering och wedding planning har vi samlat den kunskap och erfarenhet som krävs för att skapa lyckade arrangemang – från första idé till sista detalj. Vi har genom åren arbetat med allt från bröllop, företagsevent och konferenser till privata fester och större evenemang. Vår erfarenhet gör att vi vet vad som krävs för att planera, organisera och genomföra ett event med hög kvalitet och personlig service.',
    imgStart: false,
    img: require('../../Logo/logo_footer.png'),
    alt: 'catering',
    dark: true,
    primary: true,
    darkText: false,
}